import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export default async function peopleTeamSetup() {
  try {
    const result = await mushodoPromise('GetTeamSetupAndEmployees');

    if (result.error) {
      throw result.error;
    }

    return {
      success: true,
      message: '',
      data: result,
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
